import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {ordersFeatureKey, ordersReducer} from './orders.reducer';
import {OrdersEffects} from './orders.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(ordersFeatureKey, ordersReducer),
    EffectsModule.forFeature([OrdersEffects])
  ]
})
export class OrdersStoreModule {

}
